export default {
  // HINT: this list should localize all values from `p-m-u/data/verticals.js`
  verticals: {
    /* eslint-disable quote-props */
    Business: 'Business - General',
    Careers: 'Careers',
    Cars: 'Automotive',
    Celebrity: 'Celebrity',
    Computers: 'Computers',
    Cooking: 'Cooking & Recipes',
    Education: 'Education',
    Electronics: 'Consumer Electronics',
    Entertainment: 'Entertainment & Media',
    Family: 'Family',
    Financial: 'Financial',
    Fitness: 'Diet & Fitness',
    Food: 'Food & Drink',
    Gaming: 'Gaming',
    Health: 'Health & Wellness',
    Home: 'Home & Garden',
    Lifestyle: 'Lifestyle',
    Pets: 'Pets',
    RealEstate: 'Real Estate',
    Retail: 'Retail',
    Shopping: 'Shopping',
    Sports: 'Sports',
    Taxes: 'Taxes',
    Toys: 'Toys',
    Travel: 'Travel',
    Weddings: 'Weddings',
    /* eslint-enable quote-props */
  },

  // HINT: this list should localize all values from `p-m-u/data/offerings.js`
  offerings: {
    /* eslint-disable quote-props */
    product: 'Product',
    service: 'Service',
    content: 'Content',
    /* eslint-enable quote-props */
  },

  destinations: {
    /* eslint-disable quote-props */
    specific_landing: "Specific landing page (there's only one clear goal)",
    general_landing: 'General landing page (can serve a number of goals)',
    timely_landing: 'Timely landing page (offers a timely promotion)',
    content_article: 'Content — article',
    content_video: 'Content — video',
    no_destination: 'No external destination (stays in FB)',
    /* eslint-enable quote-props */
  },

  message_types: {
    /* eslint-disable quote-props */
    pitch: 'Pitch (selling something)',
    reference: 'Reference (not selling)',
    /* eslint-enable quote-props */
  },

  desired_outcomes: {
    /* eslint-disable quote-props */
    read_content: 'Read content',
    watch_video: 'Watch video',
    capture_information: 'Capture information',
    sell_product: 'Sell product or service',
    /* eslint-enable quote-props */
  },

  reject_reasons: {
    typo: 'Typo / grammar',
    brief_compliance: 'Brief compliance',
    bad_image: 'Bad image',
    low_quality: 'Low quality',
    other: 'Other',
  },

  optimizationGoal: {
    /* eslint-disable quote-props */
    none: 'None',
    brand_awareness: 'Brand awareness',
    app_installs: 'App installs',
    ad_recall_lift: 'Ad recall lift',
    clicks: 'Clicks',
    engaged_users: 'Engaged users',
    event_responses: 'Event responses',
    impressions: 'Impressions',
    lead_generation: 'Lead generation',
    link_clicks: 'Link clicks',
    offer_claims: 'Offer claims',
    offsite_conversions: 'Offsite conversions',
    page_engagement: 'Page engagement',
    page_likes: 'Page likes',
    post_engagement: 'Post engagement',
    reach: 'Reach',
    video_views: 'Video views',
    social_impressions: 'Social impressions',
    app_downloads: 'App downloads',
    landing_page_views: 'Landing page views',
    value: 'Value',
    replies: 'Replies',
    two_second_continuous_video_views: 'Two second continuous video views',
    onsite_conversions: 'Onsite conversions',
    thruplay: 'ThruPlay',
    /* eslint-enable quote-props */
  },

  FBPreview: {
    error: "Can't load facebook post preview.",
  },
};
